// removed by extract-text-webpack-plugin
module.exports = {"content":"src-scripts-components-NotificationPopoverContent-__notificationPopoverDummy___content","footerWrapper":"src-scripts-components-NotificationPopoverContent-__notificationPopoverDummy___footerWrapper","sendOnlyToInRoute":"src-scripts-components-NotificationPopoverContent-__notificationPopoverDummy___sendOnlyToInRoute","footerMessage":"src-scripts-components-NotificationPopoverContent-__notificationPopoverDummy___footerMessage","actions":"src-scripts-components-NotificationPopoverContent-__notificationPopoverDummy___actions"};


//////////////////
// WEBPACK FOOTER
// ./src/scripts/components/NotificationPopoverContent/notificationPopoverDummy.css
// module id = 2363
// module chunks = 0